/**
 * Returns the hostname of url, or undefined if url is missing or invalid.
 */
export function getHostname(url?: string): string | undefined {
  if (!url) return undefined;
  try {
    return new URL(url).hostname;
  } catch {
    return undefined;
  }
}
